import { createSlice } from '@reduxjs/toolkit';
import { ReducerType } from './types';
import { makeRandomNumberString } from '@open-tender/utils';
const initialState = [];
const alertsSlice = createSlice({
    name: ReducerType.Alerts,
    initialState,
    reducers: {
        clearAlerts: () => initialState,
        addAlert: (state, action) => {
            // const remaining = state.reverse().slice(0, 4).reverse()
            return [
                ...state,
                { message: action.payload, id: makeRandomNumberString() }
            ];
        },
        dismissAlert: (state, action) => {
            return state.filter(i => i.id !== action.payload);
        }
    }
});
export const { clearAlerts, addAlert, dismissAlert } = alertsSlice.actions;
export const selectAlerts = (state) => state.alerts;
export const alertsReducer = alertsSlice.reducer;
